module.exports = __webpack_public_path__ + "static/ic_mail@4x-195f5851eb966afb0d987f091c839939.png";